import { TONAPI_ENDPOINT, TONAPI_KEY } from '~/config.js';
import axios from 'axios';

/**
 * @see https://docs.tonconsole.com/tonapi/api-v2
 */
const http = axios.create({
    baseURL: TONAPI_ENDPOINT,
    headers: {
        Authorization: `Bearer ${TONAPI_KEY}`,
    },
});

export const getJettonChart = async (params) => {
    try {
        const response = await http.get('rates/chart', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const getJettonInfoTonapi = async function getJettonInfoByAddress(address) {
    const { data } = await http.get(`jettons/${address}`);
    return data;
};

export const getJettonsByOwnerTonapi = async function getJettonInfoByAddress(account_id, limit = 100, offset = 0) {
    const { data } = await http.get(`accounts/${account_id}/jettons`, {
        params: {
            limit,
            offset,
            // RUB too, so the token list follows the currency picked in settings:
            currencies: 'usd,rub',
            supported_extensions: ['custom_payload', 'defi'],
        },
    });
    return data;
};
